<ng-template #templateRef>
    <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">Roll Days</h5>
        <button type="button" class="close" aria-label="Close" (click)="modalRef.close('Close')">Close</button>
    </div>
    <div class="modal-body" ngbAutofocus>
        <div class="form-row mb-4">
            <div class="col-4">
                <app-dc-radio
                    [ngModel]="irregularPeriodMode"
                    (ngModelChange)="onSelectMode($event)"
                    name="irregularPeriodMode"
                    [selectValue]="IrregularPeriodModeTypes.Day"
                    id="day"
                    label="Specify roll day"
                ></app-dc-radio>
            </div>
            <div class="col">
                <app-dc-radio
                    [(ngModel)]="irregularPeriodMode"
                    name="irregularPeriodMode"
                    [selectValue]="IrregularPeriodModeTypes.Period"
                    id="period"
                    label="Specify period end/start dates"
                ></app-dc-radio>
            </div>
        </div>
        <div class="form-group">
            <div class="form-headers form-row">
                <div class="col-4"></div>
                <ng-container [ngSwitch]="irregularPeriodMode">
                    <ng-container *ngSwitchCase="IrregularPeriodModeTypes.Day">
                        <div class="col-3">Roll Day</div>
                        <div class="col-5">Irregular Periods</div>
                    </ng-container>
                    <ng-container *ngSwitchCase="IrregularPeriodModeTypes.Period">
                        <div class="col-4">Unadjusted End of First Period</div>
                        <div class="col-4">Unadjusted Start of Last Period</div>
                    </ng-container>
                </ng-container>
            </div>
            <app-roll-days-modal-row 
                class="form-group"
                *ngFor="let row of rows;"
                [form]="form.get(getFormName(row))"
                [type]="irregularPeriodMode" 
                [label]="getRowLabel(row)">
            </app-roll-days-modal-row>
        </div>
    </div>
</ng-template>